/** Minimal CSV parser supporting quoted fields, commas & newlines inside quotes,
 * and escaped double-quotes. Returns array of arrays of strings. */
export function parseCSV(text) {
  const rows = [];
  let row = [];
  let field = "";
  let inQ = false;
  const s = text.replace(/\r\n?/g, "\n");
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (inQ) {
      if (ch === '"') {
        if (s[i + 1] === '"') { field += '"'; i++; }
        else inQ = false;
      } else {
        field += ch;
      }
    } else {
      if (ch === '"') inQ = true;
      else if (ch === ",") { row.push(field); field = ""; }
      else if (ch === "\n") { row.push(field); rows.push(row); row = []; field = ""; }
      else field += ch;
    }
  }
  if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
  return rows.filter((r) => r.some((c) => (c || "").trim().length > 0));
}

/**
 * Map CSV rows -> customer objects. Auto-detects columns by header keywords.
 * Returns { items:[{name,phone,email,address}], skipped: number, columns: {name,phone,email,address} }
 */
export function mapCustomers(rows) {
  if (rows.length === 0) return { items: [], skipped: 0, columns: {} };
  const [headerRow, ...body] = rows;
  const headers = headerRow.map((h) => (h || "").trim().toLowerCase());
  const find = (keys) => {
    for (const k of keys) {
      const idx = headers.findIndex((h) => h === k || h.includes(k));
      if (idx >= 0) return idx;
    }
    return -1;
  };
  const cols = {
    name: find(["name", "customer", "client", "contact"]),
    phone: find(["phone", "mobile", "cell", "tel"]),
    email: find(["email", "mail", "e-mail"]),
    address: find(["address", "street", "location"]),
  };
  const items = [];
  let skipped = 0;
  for (const r of body) {
    const name = (r[cols.name] || "").trim();
    if (!name) { skipped++; continue; }
    items.push({
      name,
      phone: (r[cols.phone] || "").trim(),
      email: (r[cols.email] || "").trim(),
      address: (r[cols.address] || "").trim(),
    });
  }
  return { items, skipped, columns: cols };
}
